import React from 'react';
import { GetRecipe } from '../../constants/assets';

const Recipe = (props) => {
    const { number, goToPlaySection } = props;
    const links = [
        'https://bit.ly/2znDytb',
        'https://bit.ly/2Q55EmL',
        'https://bit.ly/2Q54J5N',
        'https://bit.ly/2Ko5zoO',
        'https://bit.ly/2zlDVoa',
        'https://bit.ly/2DP0s0y',
        'https://bit.ly/2AbMuRR',
        'https://bit.ly/2BnGMhK',
        'https://bit.ly/2OSD2Iz',
        'https://bit.ly/2zm1g9d',
        'https://bit.ly/2S5Weoh',
        'https://bit.ly/2QUhzAO',
        'https://bit.ly/2RZvMg2',
        'https://bit.ly/2TwoK3K',
        'https://bit.ly/2DA4Saz',
        'https://bit.ly/2TvovWI',
        'https://bit.ly/2BnEz68',
        'https://bit.ly/2S1KLWE',
        'https://bit.ly/2FzXeQ0',
        'https://bit.ly/2Turkaz',
        'https://bit.ly/2qSTOhg',
        'https://bit.ly/2TraB86',
        'https://bit.ly/2QdaNZM',
        'https://bit.ly/2FvuW9y',
    ];
    const randomNum = number ? number : Math.floor(Math.random() * 24) + 1;
    // const getUrl = window.location;
    // const urlToShare = encodeURIComponent(`${getUrl.origin}/prize-winned/recipe/${randomNum}`);
    const urlToShare = encodeURIComponent(links[randomNum - 1]);

    const shareOnFB = () => {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + urlToShare, "_blank");
    };

    return (
        <div className="recipe-section">
            <button onClick={goToPlaySection} className="close-top-button"></button>
            <GetRecipe number={randomNum} />
            <div className="recipe-buttons">
                <button onClick={shareOnFB} className="share-button"></button>
                <a href={links[randomNum - 1]} target="_blank" rel="noopener noreferrer">Ver receta</a>
            </div>
            <div className="recipe-sphere"></div>
        </div>
    );
};

export default Recipe;
